import { render } from "./Header.vue?vue&type=template&id=d7dabe80&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=d7dabe80&scoped=true&lang=css"

import exportComponent from "/Volumes/DEXP W500C/homePc/актуально/new-dff/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7dabe80"]])

export default __exports__